import { render, staticRenderFns } from "./ManutencaoCarrosDetalhesView.vue?vue&type=template&id=51a5a2f8&"
import script from "./ManutencaoCarrosDetalhesView.vue?vue&type=script&lang=ts&"
export * from "./ManutencaoCarrosDetalhesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports